import React from 'react';
import {connect} from 'react-redux';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
import LANGUAGES_CONTROLLER from "../../../controllers/languages";
import { SSelect } from "@avalara/skylab-sdk/react";

const log = new Logger('SINGLE_DUE_DATE_SELECTOR', LOG_LEVELS.DEBUG);

export class SingleDueDatePeriodSelector extends React.Component {

    selectionChangeHandlerFactory(fieldName) {
        return (event) => {
            log.debug('selectionChangeHandlerFactory(%s): %s, ', fieldName, event);
            let selection = {};
            selection[fieldName] = event.detail.item.value !== '' ? event.detail.item.value : undefined;
            this.props.selectionHandler(selection);
        }
    }

    getDueDatePeriodOptions() {
        let optionsList = [];
        this.props.dueDatePeriodList && this.props.dueDatePeriodList.forEach((period, key) => {
            optionsList.push({
                label: LANGUAGES_CONTROLLER.format(this.props.languages, period.languageString),
                value: period.id+"",
                selected: this.props.selectedDueDatePeriod === (period.id+"")? true: false
            });
        })
        return optionsList;
    }

    render() {
        log.debug('render(): ', this.props);
        return (
            <div data-test="component-single-dueDatePeriod-selector">
            <SSelect defaultValue={this.props.selectedDueDatePeriod} 
                inputId="single-dueDatePeriod-select"
                name="roles"
                onS-select={this.selectionChangeHandlerFactory(this.props.fieldName).bind(this)}
                optionsList={this.getDueDatePeriodOptions() || []}
                multiple={false}
                showSelectionCount={false}
            />
            </div>
        )
    }
}


function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(SingleDueDatePeriodSelector);